import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import GroupManager from '../../../../views/GroupManager/GroupManager';

const GroupManagerPageRoute = () => {
    return (    
        <Routes>
            <Route path="" element={<GroupManager />} />            
        </Routes>        
    );
};

export default GroupManagerPageRoute;